export default "__VITE_ASSET__BRAGojTi__"